<template>
    <plan-contract-cart-item
        v-if="itemData.contract.__typename === 'PlanContract'"
        :contract="itemData.contract"
        :total="subtotal"
        :non-discounted-subtotal="nonDiscountedSubtotal"
        :gift-card-loaded-value="giftCardLoadedValue"
        :gift-card-bonus-amount="giftCardBonusAmount"
        :due-today="dueToday"
    />

    <prime-message
        v-else
        severity="error"
        :closable="false"
    >
        {{ t('cartSidebar.customContractUnavailable') }}
    </prime-message>
</template>

<script lang="ts">
import { graphql } from '~/resources/graphql'

export const CartSidebarContractCartItemFragment = graphql(/* GraphQL */ `
    fragment CartSidebarContractCartItemFragment on CartContractItem {
        contract {
            __typename
            ... on PlanContract {
                ...PlanContractCartItemFragment
            }
        }
        subtotal
        nonDiscountedSubtotal
        giftCardLoadedValue
        giftCardBonusAmount
        dueToday
    }
`)
</script>

<script setup lang="ts">
import PrimeMessage from 'primevue/message'
import { useI18n } from 'vue-i18n'
import { Decimal } from '~/composables/support/decimal'
import type { FragmentType } from '~/resources/graphql'
import { getFragmentData } from '~/resources/graphql'
import { computed } from 'vue'
import PlanContractCartItem from '~/components/CartSidebar/PlanContractCartItem.vue'

const props = defineProps<{
    item: FragmentType<typeof CartSidebarContractCartItemFragment>
}>()

const { t } = useI18n({ useScope: 'global' })

const itemData = computed(() =>
    getFragmentData(CartSidebarContractCartItemFragment, props.item)
)

const subtotal = computed(() => new Decimal(itemData.value.subtotal))
const nonDiscountedSubtotal = computed(
    () => new Decimal(itemData.value.nonDiscountedSubtotal)
)
const giftCardLoadedValue = computed(() =>
    itemData.value.giftCardLoadedValue !== null
        ? new Decimal(itemData.value.giftCardLoadedValue)
        : null
)
const giftCardBonusAmount = computed(() =>
    itemData.value.giftCardBonusAmount !== null
        ? new Decimal(itemData.value.giftCardBonusAmount)
        : null
)
const dueToday = computed(() =>
    itemData.value.dueToday !== null
        ? new Decimal(itemData.value.dueToday)
        : null
)
</script>
